import { styled } from '@pulse-web-ui/theme';

export const IconContainer = styled.div`
  transform: rotate(135deg);
`;
